<template>
  <div>
    <p class="text-caption text--secondary">
      O telefone vincula um usuário da plataforma. A porcentagem incide sobre o
      valor total da fatura e gera uma saída pendente na categoria Comissão
      quando a fatura fecha.
    </p>
    <v-form ref="form" v-model="valid" @submit.prevent>
      <phone-input
        :phone="form.phone"
        label="Telefone do comissionado"
        :ddi="form.ddi"
        dense
        outlined
        :disabled="loading"
        @update:phone="(value) => (form.phone = value)"
        @update:ddi="(value) => (form.ddi = value)"
      />
      <v-text-field
        v-model.number="form.percentage"
        label="Porcentagem"
        outlined
        dense
        type="number"
        min="0"
        max="100"
        step="0.01"
        suffix="%"
        :disabled="loading"
        :rules="percentageRules"
      />
      <v-alert v-if="linkedName" type="info" text dense>
        Vinculado a {{ linkedName }}
      </v-alert>
      <v-alert v-if="error" type="error" text dense>
        {{ error }}
      </v-alert>
      <div class="d-flex justify-end" style="gap: 8px">
        <v-btn
          v-if="commissionId"
          text
          color="error"
          :disabled="loading"
          @click="removeCommission"
        >
          Remover
        </v-btn>
        <v-btn
          color="success"
          depressed
          :disabled="loading || !valid"
          :loading="saving"
          @click="save"
        >
          Salvar
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import COMPANY from "@/services/ultimate/company";
import PhoneInput from "@/components/global/PhoneInput.vue";

const emptyForm = () => ({
  phone: "",
  ddi: 55,
  percentage: null,
});

export default {
  name: "CompanyCommission",
  components: { PhoneInput },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    valid: false,
    loading: false,
    saving: false,
    error: null,
    commissionId: null,
    linkedName: null,
    form: emptyForm(),
    percentageRules: [
      (value) =>
        (value !== "" &&
          value !== null &&
          value !== undefined &&
          !Number.isNaN(Number(value))) ||
        "Porcentagem é obrigatória",
      (value) =>
        (Number(value) >= 0 && Number(value) <= 100) ||
        "Informe um valor entre 0 e 100",
    ],
  }),
  watch: {
    "company.id": {
      handler() {
        this.loadCommission();
      },
      immediate: true,
    },
  },
  methods: {
    async loadCommission() {
      if (!this.company?.id) return;
      try {
        this.loading = true;
        this.error = null;
        const { commission } = await COMPANY.getCommission(this.company.id);
        this.applyCommission(commission);
      } catch (error) {
        this.error = error.message || "Erro ao carregar comissão";
      } finally {
        this.loading = false;
      }
    },
    applyCommission(commission) {
      if (!commission) {
        this.commissionId = null;
        this.linkedName = null;
        this.form = emptyForm();
        return;
      }
      this.commissionId = commission.id;
      this.linkedName = commission.userName || commission.userPhone;
      this.form = {
        phone: commission.userPhone || "",
        ddi: commission.ddi || 55,
        percentage: commission.percentage,
      };
      this.$nextTick(() => this.$refs.form?.validate());
    },
    async save() {
      try {
        this.saving = true;
        this.loading = true;
        this.error = null;
        const { commission } = await COMPANY.upsertCommission(this.company.id, {
          ddi: this.form.ddi,
          phone: this.form.phone,
          percentage: this.form.percentage,
        });
        this.applyCommission(commission);
      } catch (error) {
        this.error = error.message || "Erro ao salvar comissão";
      } finally {
        this.saving = false;
        this.loading = false;
      }
    },
    async removeCommission() {
      if (!window.confirm("Remover a comissão desta empresa?")) return;
      try {
        this.loading = true;
        this.error = null;
        await COMPANY.deleteCommission(this.company.id);
        this.applyCommission(null);
      } catch (error) {
        this.error = error.message || "Erro ao remover comissão";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
